//================================================================
//  Page: PermissionSets 
//================================================================

//  Purpose: PermissionSets Tab

//================================================================

// Libraries
import React, { useContext, useState, useReducer, useEffect } from 'react';

// Contexts
import { GetRoles, GetUser } from '../../../../../Library/GlobalContexts';

// Components
import PageComponent from '../../../../../Components/PageComponent/PageComponent';
import TabView from '../../../../../Components/TabView/TabView';
import AccessDeniedInventory from '../../../../../Components/PageComponent/Components/AccessDeniedInventory';
import AdminUserTable from './Components/AdminUserTable';


export default function PermissionSets() {

  //------------------------------------------------------
  //  useContext
  //------------------------------------------------------

  const getUser = useContext(GetUser);
  const getRoles = useContext(GetRoles);

  //------------------------------------------------------
  //  useStates & useReducer
  //------------------------------------------------------

  // Used to change between > 'pending', 'onload', 'error'
  const [pageStatus, setPageStatus] = useState('pending');

  // Used to store the search data
  const [permissionsData, setPermissionsData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      // Current Users Roles
      'agreementAdmin': false,
      'applicationAdmin': false,
      'vendorAdmin': false,
      'subnetsAdmin': false,

      // Users
      'agreements': [],
      'applications': [],
      'vendors': [],
      'subnets': [],
    }
  );

  //------------------------------------------------------
  //  useEffect
  //------------------------------------------------------

  // onLoad
  //  1. Map all the users roles for each tab
  useEffect(() => {

    if (getUser === undefined) return;
    if (getRoles === undefined) return;

    // Map roles to tabs
    setPermissionsData({

      // Current Users Roles
      'agreementAdmin': getRoles?.['agreements']?.[getUser.emailaddress]?.admin,
      'applicationAdmin': getRoles?.['applications']?.[getUser.emailaddress]?.admin,
      'vendorAdmin': getRoles?.['vendors']?.[getUser.emailaddress]?.admin,
      'subnetsAdmin': getRoles?.['subnets']?.[getUser.emailaddress]?.admin,

      // Users
      'agreements': Object.keys(getRoles?.['agreements']),
      'applications': Object.keys(getRoles?.['applications']),
      'vendors': Object.keys(getRoles?.['vendors']),
      'subnets': Object.keys(getRoles?.['subnets']),

    });

    // Load page
    setPageStatus('onload');

  }, [getUser, getRoles]);

  //------------------------------------------------------
  //  HTML
  //------------------------------------------------------

  return (

    <PageComponent
      status={pageStatus}
      header={
        <div className='flex flex-col p-4 gap-1 bg-neutral-100 w-full border-solid border-1 border-neutral-300'>
          <h4 className='flex items-center h-full cursor-default text-[22px]'>
            Permission Sets
          </h4>
          <p className='text-[#424242] font-sans text-[16px] leading-[24px] m-0'></p>
        </div>
      }
      body={
        <TabView
          defaultView={1}

          // ======== Agreements ======== //
          oneTitle={'Agreements'}
          oneRoute='/settings?tab=permissions&view=agreements'
          oneContent={

            permissionsData.agreementAdmin !== true ?

              <AccessDeniedInventory
                portal={'Inventory'}
                overridePermissionValue={'Administrator'}
              ></AccessDeniedInventory>
              :
              <AdminUserTable
                documentid={'agreements'}
                permissionsData={permissionsData}
              ></AdminUserTable>
          }

          // ======== Applications ======== //
          twoTitle={'Applications'}
          twoRoute='/settings?tab=permissions&view=applications'
          twoContent={

            permissionsData.applicationAdmin !== true ?

              <AccessDeniedInventory
                portal={'Inventory'}
                overridePermissionValue={'Administrator'}
              ></AccessDeniedInventory>
              :
              <AdminUserTable
                documentid={'applications'}
                permissionsData={permissionsData}
              ></AdminUserTable>

          }

          // ======== Vendors ======== //
          threeTitle={'Vendors'}
          threeRoute='/settings?tab=permissions&view=vendors'
          threeContent={

            permissionsData.vendorAdmin !== true ?

              <AccessDeniedInventory
                portal={'Inventory'}
                overridePermissionValue={'Administrator'}
              ></AccessDeniedInventory>
              :
              <AdminUserTable
                documentid={'vendors'}
                permissionsData={permissionsData}
              ></AdminUserTable>

          }

          // ======== IPAM (Subnets) ======== //
          fourTitle={'IPAM (Subnets)'}
          fourRoute='/settings?tab=permissions&view=subnets'
          fourContent={

            permissionsData.subnetsAdmin !== true ?

              <AccessDeniedInventory
                portal={'Inventory'}
                overridePermissionValue={'Administrator'}
              ></AccessDeniedInventory>
              :
              <AdminUserTable
                documentid={'subnets'}
                permissionsData={permissionsData}
              ></AdminUserTable>
          }
        > </TabView>
      }

    ></PageComponent>

  )

}
